import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_right",
  "use": "chevron_right-usage",
  "viewBox": "0 0 13.97 25.59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.97 25.59\" id=\"chevron_right\"><path d=\"M1.17 25.58a1.19 1.19 0 0 1-.84-2.03l10.75-10.77L.33 2.01A1.188 1.188 0 0 1 2.01.33l11.58 11.61a1.177 1.177 0 0 1 0 1.68L2.01 25.23a1.216 1.216 0 0 1-.84.35Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol